export default __webpack_public_path__ + "static/media/No9.afc4d9fd.jpg";